import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NoteTypeEnum } from 'app/shared/components/note/note-type.enum';
import { SmartSnackDataModel } from './smart-snack-data.model';
import { NoteComponent } from '../../../../shared/components/note/note.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-smart-snack',
  styleUrls: ['./smart-snack.component.scss'],
  templateUrl: './smart-snack.component.html',
  imports: [NoteComponent, MatIconButton, MatIcon],
})
export class SmartSnackComponent {
  public data = inject<SmartSnackDataModel>(MAT_SNACK_BAR_DATA);
  public hasAction = false;
  public messageArrayFlag = false;
  public messageTypeError = NoteTypeEnum.Error;
  public messageTypeInformation = NoteTypeEnum.Information;
  public messageTypeWarning = NoteTypeEnum.Warning;

  private _snackBarRef = inject<MatSnackBarRef<SmartSnackComponent>>(MatSnackBarRef);

  public constructor() {
    if (this.data.actionFunction) {
      this.hasAction = true;
    }

    if (this.data.notes instanceof Array) {
      this.messageArrayFlag = true;
    }
  }

  public close(): void {
    this._snackBarRef.dismissWithAction();
  }

  public performAction(): void {
    if (this.data) {
      this.data.actionFunction!();
    }
    this.close();
  }
}
